import firmador from './firmador'
import apitest from './apitest'
//import apiprod from './apiprod'

export default {
    firmador,
    apitest
}